import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackClientEvent } from 'analytics/analytics'
import type { SupportedLoyaltyActionReward } from 'loyalty/constants/loyaltyActionRewards'
import type { LoyaltyActionRewardCTANavDestination } from 'loyalty/lib/getLoyaltyActionRewardCTANav'
import getLoyaltyActionRewardProgress from 'loyalty/lib/getLoyaltyActionRewardProgress'

export const LOYALTY_QUESTS_TRACKING_CATEGORY = 'loyalty_quests'

function getQuestClickDestinationUrl(destination: LoyaltyActionRewardCTANavDestination): string {
  return destination.kind === 'external' ? destination.href : destination.to
}

function getQuestClickProgress(reward: SupportedLoyaltyActionReward): string {
  const progress = getLoyaltyActionRewardProgress(reward)
  if (progress.kind === 'unlimited') {
    return `${progress.appliedCount}/unlimited`
  }

  return `${progress.appliedCount}/${progress.target}`
}

export function trackLoyaltyActionRewardQuestClick(
  reward: SupportedLoyaltyActionReward,
  destination: LoyaltyActionRewardCTANavDestination,
  itemPosition: number,
) {
  const pointsEarn = reward.earnEstimate?.bonusPoints ?? 0
  const progress = getQuestClickProgress(reward)
  const destinationUrl = getQuestClickDestinationUrl(destination)

  trackClientEvent({
    category: LOYALTY_QUESTS_TRACKING_CATEGORY,
    action: 'clicked',
    subject: reward.actionName,
    type: 'interaction',
    context: [
      comluxgroup.createListItem_1_0_0({
        listName: LOYALTY_QUESTS_TRACKING_CATEGORY,
        listInstance: JSON.stringify({
          destinationUrl,
          progress,
          pointsEarn,
        }),
        itemPosition,
      }),
    ],
  })
}
